export default __webpack_public_path__ + "static/media/raspberry-custard-doughnuts.972548c4.png";